import React, { FunctionComponent } from 'react';
import { cloneDeep } from 'lodash';
import { Application, Form } from '../../../../store/modules/application/types';
import Loader from '../../../../components/Loader';
import FormDisplay from '../../../../components/FormDisplay';
import { getObjectChanges } from '../../../../utils/utils';

type LicenseDataProps = { isLoading: boolean; application: Application; updateLicense: Function; editForm: Form };

const LicenseData: FunctionComponent<LicenseDataProps> = (props) => {
    const { application, editForm, isLoading, updateLicense } = props;

    const handleSave = (updatedLicense: Application) => {
        updateLicense(getObjectChanges(application, updatedLicense), application.id);
    };

    if (isLoading) return <Loader />;

    return <FormDisplay form={editForm} record={cloneDeep(application)} handleSave={handleSave} />;
};

export default LicenseData;
